import { db } from '../config/firebase';
import { collection, getDocs, query, orderBy, doc, getDoc, setDoc, updateDoc, arrayUnion, serverTimestamp } from 'firebase/firestore';

export const getOnboardingQuestions = async () => {
  try {
    const q = query(
      collection(db, 'onboarding_questions'),
      orderBy('stage', 'asc'),
      orderBy('order', 'asc')
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error getting questions:', error);
    throw error;
  }
};

export const getUserProgress = async (userId) => {
  try {
    const userRef = doc(db, 'user_progress', userId);
    const docSnap = await getDoc(userRef);
    return docSnap.exists() ? docSnap.data() : null;
  } catch (error) {
    console.error('Error getting user progress:', error);
    throw error;
  }
};

export const updateUserProgress = async (userId, stage, answers) => {
  try {
    const userRef = doc(db, 'user_progress', userId);
    const progressData = {
      currentStage: stage,
      lastUpdated: serverTimestamp(),
      [`stages.${stage}`]: {
        completed: true,
        completedAt: serverTimestamp(),
        answers
      }
    };
    
    await setDoc(userRef, progressData, { merge: true });
  } catch (error) {
    console.error('Error updating user progress:', error);
    throw error;
  }
};
